import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL.endsWith("/")
  ? process.env.REACT_APP_API_URL
  : process.env.REACT_APP_API_URL + "/";

export const searchTestsBySymptom = async (params) => {
  try {
    let symptomId, pageNumber = 1, pageSize = 10, name = "", labId = 0;

    if (typeof params === "object") {
      symptomId = params.symptomId;
      pageNumber = params.pageNumber || 1;
      pageSize = params.pageSize || 10;
      name = params.name || "";
      labId = params.labId || 0;
    } else {
      symptomId = params;
    }

    const res = await axios.post(`${BASE_URL}Lab/TestSearch`, {
      name,
      labId,
      symptomId: Number(symptomId),
      pageNumber,
      pageSize,
    });

    // ✅ extract 'data' array from response
    return Array.isArray(res.data?.data) ? res.data.data : [];
  } catch (error) {
    console.error("❌ API Error:", error.response?.data || error.message);
    throw error;
  }
};